import { combineLatest } from 'rxjs/observable/combineLatest';
import { SettingsProvider } from './../settings/settings';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase } from '../../../node_modules/angularfire2/database';
import { LiveSignal, SignalData, PriceData } from './../../models/Signal';
import { ThenableReference } from '../../../node_modules/@firebase/database-types';
import "rxjs/add/operator/catch"
import { UserProvider } from '../user/user';
import { ModalController } from 'ionic-angular';

/*
  Generated class for the SignalsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SignalsProvider {

    maxSignal: number = null; //Timestamp of the latest signal posted
    lastSignal: number = Infinity; //Timestamp of the last signal seen
    viewingSignals: boolean = false;

    allSignals: Observable<LiveSignal[]>;
    allSignalsStocks: Observable<LiveSignal[]>;
    
    constructor(
        private db: AngularFireDatabase,
        private settings: SettingsProvider,
        private user: UserProvider,
        private modalCtrl: ModalController
    ) {

        this.allSignals = this.getAllSignalsObservable(false).shareReplay(1);
        this.allSignalsStocks = this.getAllSignalsObservable(true).shareReplay(1);

        this.getLastSeenSignal()
            .flatMap(lastSignal => {
                this.lastSignal = lastSignal
                return this.allSignals;
            })
            .subscribe(signals => {
                let signal: LiveSignal;

                if (signals.length > 0) {
                    signal = signals[0];
                }
                if (signal) {
                    this.maxSignal = parseInt(signal.data.timestamp);
                    if (this.hasUnseenSignals() && !this.viewingSignals) {
                        this.notifyNewSignal(signal);
                    }
                }
            })
    }

    private getAllSignalsObservable(stocks = false): Observable<LiveSignal[]> {
        let path = `liveSignals`;
        if(stocks) path = 'signals-stocks'

        return combineLatest(this.user.hasAccess(), this.user.isAdmin()).switchMap(access => {
            let hasAccess = access[0];
            let isAdmin = access[1];
            if (!(hasAccess || isAdmin)) return Observable.of([]);
            return this.db.list<SignalData>(path, ref => ref.orderByChild('timestamp'))
                .snapshotChanges()
                .map(snapshot => {
                    let liveSignals = [];
                    for (let snap of snapshot) {
                        const signal: SignalData = snap.payload.val();
                        const liveSignal: LiveSignal = new LiveSignal(signal);
                        liveSignal.key = snap.key;
                        liveSignals.push(liveSignal)
                        // console.log(liveSignal.key);
                    }
                    return liveSignals.reverse();
                }).catch((error, caught) => {
                    console.log(error);
                    return Observable.of([]);
                })
        })
    }

    public getAllSignals(stocks = false): Observable<LiveSignal[]> {
        if(stocks) return this.allSignalsStocks;
        return this.allSignals;
    }

    private getLastSeenSignal(): Observable<number> {
        return this.settings
            .getUserSettings()
            .map(settings => {
                if (settings)
                    return settings.lastSignal;
                else
                    return Infinity;
            })
    }

    public getSignalsMeta(stocks = false): Observable<any> {
        let path = 'signalsMeta';
        if(stocks) path = 'signalsMeta-stocks';

        return this.db.object<any>(path).valueChanges();
    }

    public addSignal(signal: LiveSignal): ThenableReference {
        let path = 'liveSignals';
        if(signal.data.isStock) path = 'signals-stocks';

        return this.db.database.ref(path).push(signal.data);
    }

    public editSignal(signal: LiveSignal): Promise<void> {
        if (!signal.key) return;
        let path = `liveSignals/${signal.key}`;
        if(signal.data.isStock) path = `signals-stocks/${signal.key}`;

        return this.db.database.ref(path).update(signal.data);
    }

    public removeSignal(signal: LiveSignal): Promise<void> {
        if (!signal.key) return;
        let path = `liveSignals/${signal.key}`;
        if(signal.data.isStock) path = `signals-stocks/${signal.key}`;

        return this.db.database.ref(path).remove();
    }

    public hasUnseenSignals(): boolean {
        // console.log(this.maxSignal, this.lastSignal);
        if (this.maxSignal) {
            if (!this.lastSignal) return true;
            return this.maxSignal > this.lastSignal;
        } else {
            return false;
        }
    }


    public clearCount() {
        let sub = this.getLastSeenSignal().subscribe(lastSignal => {
            if (lastSignal != Infinity) {
                this.setUserMaxSignal(this.maxSignal).subscribe();
            }
            sub.unsubscribe();
        })
    }

    private notifyNewSignal(signal: LiveSignal) {
        // this.coins.getCoinByName(signal.data.coin).subscribe(coin =>{
        // if(!coin.ImageUrl) return;
        // this.settings.notify(signal, coin);
        // })

    }

    private setUserMaxSignal(timestamp: number): Observable<void> {
        let payload = { lastSignal: timestamp };
        return this.settings.setUserSettings(payload);
    }



    public getSignalByID(id: string, stock = false): Promise<LiveSignal> {
        let observable = stock ? this.allSignalsStocks : this.allSignals;
        return observable.first().toPromise()
            .then(signals => {
                for (let signal of signals) {
                    if (signal.key == id) return signal;
                }
                return null;
            })
            .catch(error => { return null });
    }
}



// WEBPACK FOOTER //
// ./src/providers/signals/signals.ts